<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать основной' : 'Показать все'" :expandable="otherActivities.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Виды деятельности ({{items.length}})
        <div><b v-html="formatMainActivityHtml(mainActivity)"></b></div>
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <v-flex v-if="items.length===0">
      Данные не найдены.
      </v-flex>                
      <template v-for="item in otherActivities">
        <div>{{item.code}}&#9;{{item.name}}</div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-records-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      activities: {
        type: Array,
        default () {
          return []
        }
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      mainActivity () {
        var result = this.items.filter(a => a.isMain)
        return result.length > 0 ? result[0].code + '\t' + result[0].name : null
      },
      otherActivities () {
        return this.items.filter(a => !a.isMain).sort((a, b) => formats.compareString(a.code, b.code))
      },
      items () {
        return this.activities
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          // this.fetchItems()
        }
      },
      formatMainActivityHtml (activity) {
        return activity && activity.length > 0 ? activity : formats.formatWarningHtml('Регистр не содержит запись об основном виде деятельности')
      }
    }
  }

</script>


// WEBPACK FOOTER //
// ActivitiesPanel.vue?8ea48e88